import React from "react";
import PropTypes from "prop-types";
import radium, { Style } from "radium";
import { Link } from "react-scroll";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import colors from "backpack-ui/dist/styles/colors";
import mq from "backpack-ui/dist/styles/mq";
import timing from "backpack-ui/dist/styles/timing";
import {
  fontSizeBodySmall,
  fontSizeHeading6,
  fontSizeHeading7,
  fontWeightMedium,
  lineHeightHeading6,
  lineHeightHeading7,
} from "backpack-ui/dist/styles/typography";
import WorldNomadSidebarCallout from "../worldNomadsWidget/worldNomadSidebarCallout";

const styles = {
  list: {
    [`@media (min-width: ${mq.min["768"]})`]: {
      maxWidth: "188px",
    },
  },
};

const narrativeMenuRules = {
  li: {
    borderBottom: `1px solid ${colors.borderPrimary}`,
    fontSize: `${fontSizeHeading6}px`,
    lineHeight: lineHeightHeading6,
    listStyleType: "none",
  },
  ".inner-list li": {
    borderBottom: "none",
    fontSize: fontSizeBodySmall,
    color: colors.textSecondary,
  },
  "li:last-child": {
    borderBottom: 0,
  },
  "li.menu-item a": {
    color: colors.textPrimary,
    cursor: "pointer",
    display: "block",
    fontWeight: fontWeightMedium,
    overflow: "hidden",
    paddingBottom: "24px",
    paddingTop: "24px",
    textOverflow: "ellipsis",
    transition: `color ${timing.fast} ease`,
    whiteSpace: "nowrap",
    width: "90%",
  },
  "li a:hover, li a:active, li a:focus": {
    color: colors.textSecondary,
  },
  "li.active a": {
    color: colors.linkPrimary,
  },

  mediaQueries: {
    [`(min-width: ${mq.min["768"]})`]: {
      li: {
        fontSize: `${fontSizeHeading7}px`,
        lineHeight: lineHeightHeading7,
      },
    },
  },
};

const NarrativeSideMenu = ({
  links,
  activeLink,
  narrativeIntro,
  toggleMenu,
  isMobile,
  showInsuranceCallout,
}) => {
  const LinkType = isMobile ? "a" : Link;
  return (
    <ul
      className="NarrativeSideMenu"
      style={styles.list}
    >
      <Style
        scopeSelector=".NarrativeSideMenu"
        rules={narrativeMenuRules}
      />

      {narrativeIntro &&
        <li
          key={`narrative-${narrativeIntro}`}
          className={`menu-item ${narrativeIntro}${narrativeIntro === activeLink ? " active" : ""}`}
        >
          <LinkType
            duration={500}
            isDynamic
            offset={-15}
            onClick={toggleMenu}
            smooth
            to={narrativeIntro}
            href={`#${narrativeIntro}`}
          >
            Intro
          </LinkType>
        </li>
      }

      {links.length > 1 && links.map(link => (
        <li
          key={link.href}
          className={`menu-item ${link.href}${link.href === activeLink ? " active" : ""}`}
        >
          <LinkType
            duration={500}
            isDynamic
            offset={-15}
            onClick={toggleMenu}
            smooth
            to={link.href}
            href={`#${link.href}`}
          >
            {link.title}
          </LinkType>
        </li>
      ))}
      <ReactCSSTransitionGroup
        transitionName="fadeIn"
        transitionAppear
        transitionAppearTimeout={500}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}
      >
        {showInsuranceCallout && !isMobile &&
          <WorldNomadSidebarCallout />
        }
      </ReactCSSTransitionGroup>
    </ul>
  );
};

NarrativeSideMenu.propTypes = {
  links: PropTypes.array,
  activeLink: PropTypes.string,
  narrativeIntro: PropTypes.string,
  toggleMenu: PropTypes.func,
  showInsuranceCallout: PropTypes.bool,
  isMobile: PropTypes.bool,
};

NarrativeSideMenu.defaultProps = {
  links: [],
  activeLink: "",
  narrativeIntro: "",
  toggleMenu: null,
};

export default radium(NarrativeSideMenu);



// WEBPACK FOOTER //
// ./assets/pois/components/narrativeSideMenu/index.jsx